import { useRef, useCallback } from 'react';

export const useFocus = <T extends HTMLElement>(): [React.RefObject<T>, () => void] => {
    const htmlElRef = useRef<T>(null);
    const setFocus = useCallback(() => htmlElRef.current?.focus(), []);

    return [htmlElRef, setFocus];
};
